import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import darkLogo from "../../assets/img/general/logo-dark.png";

import { useGoogleLogin } from "@react-oauth/google";
import { Formik } from "formik";
import * as Yup from "yup";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import toast from "react-hot-toast";
import { RestfullApiService } from "../../config/service";

import "./auth.css";
import OtpInput from "../../utils/OtpInput";
import OtpCustomModal from "./OtpCustomModal";
import GoogleIcon from "../../assets/img/icons/google.png";
import { useDispatch } from "react-redux";
import { setLoginAttempt, setProfile } from "../../redux/slices/userSlice";

function LoginForm({ setShowEmailForm, setShowLoginForm }) {
  const [user, setUser] = useState();
  const [otpOwner, setOTPOwner] = useState();
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [verifyingMobile, setVerifyingMobile] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const glogin = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.log("Login Failed:", error),
  });
  const validationSchema = Yup.object({
    phone: Yup.string()
      .required("Phone number is required")
      .matches(/^\d{10}$/, "Phone number is not valid"),
  });
  const handlePhoneChange = (phone, formik) => {
    // Remove the country code (+91)
    const phoneWithoutCountryCode = phone.replace(/^\+91/, "");
    formik.setFieldValue("phone", phoneWithoutCountryCode);
  };
  const handleSendOtp = async (phone_no) => {
    const phoneWithoutCountryCode = phone_no.replace(/^\+91/, "");
    const reqdata = {
      Method_Name: "Send",
      Otp_Send_On: phoneWithoutCountryCode,
      Send_On_Type: "MOB",
      Module: "PAR",
      Opt_Type: "LOGIN",
    };
    try {
      setVerifyingMobile(true);

      const result = await RestfullApiService(reqdata, "master/Send_Otp");
      if (result) {
        console.log(result?.data?.Result);

        setOTPOwner(phone_no);

        setShowOtpInput(true);

        return result;
      }
    } catch (err) {
      console.log(err);
      toast.error("Internal Server Error");
    } finally {
      setVerifyingMobile(false);
    }
  };
  const handleResendOTP = async (phone_no) => {
    const phoneWithoutCountryCode = phone_no.replace(/^\+91/, "");
    const reqdata = {
      Method_Name: "Resend",
      Otp_Send_On: phoneWithoutCountryCode,
      Send_On_Type: "MOB",
      Module: "PAR",
      Opt_Type: "LOGIN",
    };
    try {
      setVerifyingMobile(true);

      const result = await RestfullApiService(reqdata, "master/Send_Otp");

      if (result) {
        const otp = result?.data?.Result?.Table1[0]?.Result_Extra_Key;

        // toast.success(<CustomSuccessToast otp={otp} />, {
        //   duration: 30000, // Set duration to 0 to keep the toast until manually dismissed
        // });

        setOTPOwner(phone_no);

        return result;
      }
    } catch (err) {
      console.log(err);
      toast.error("Internal Server Error");
    } finally {
      setVerifyingMobile(false);
    }
  };
  const handleVerifyOtp = async (phone_no, otp) => {
    const phoneWithoutCountryCode = phone_no.replace(/^\+91/, "");
    const reqdata = {
      Otp_Send_On: phoneWithoutCountryCode,
      Send_On_Type: "MOB",
      Module: "PAR",
      Opt_Type: "LOGIN",
      Otp: otp,
    };
    try {
      setVerifyingOtp(true);

      const result = await RestfullApiService(
        reqdata,
        "participant/signinwithmobileotp"
      );
      console.log(result?.data);
      if (result?.data?.Result?.Table1[0]?.Result_Id === -1) {
        toast.error(result?.data?.Result?.Table1[0]?.Result_Description);
        return;
      }

      const apiResponse = {
        userProfile: result?.data?.Result?.Table1[0],
        token: result?.data?.Description,
        we3_key: result?.data?.Key,
      };

      if (!result?.data?.Result?.Table1[0]?.Is_Email_Verified) {
        dispatch(setLoginAttempt(apiResponse));

        setShowEmailForm(true);
      } else {
        toast.success("OTP Verified");
        dispatch(setProfile(apiResponse));

        setShowEmailForm(false);
        setShowLoginForm(false);
      }
      setShowOtpInput(false);
      return result;
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.Result?.Table1[0]?.Result_Description);
    } finally {
      setVerifyingOtp(false);
    }
  };
  const handleGoogleLogin = async (values) => {
    const reqdata = {
      Profile_Image: values.picture,
      First_Name: values.name ? values.name : values.email.split("@")[0],
      Last_Name: "",
      Email_Id: values.email,
      Phone_Number: "",
      Google_Id: values.id,
      Signin_Type: "Google",
    };
    try {
      const result = await RestfullApiService(
        reqdata,
        "participant/signinwithgoogle"
      );
      if (result?.data?.Result?.Table1[0]?.Result_Id === -1) {
        toast.error(result?.data?.Result?.Table1[0]?.Result_Description);
        return;
      }
      if (result) {
        console.log(result?.data?.Result);

        if (!result?.data?.Result?.Table1[0]?.Is_Mobile_Verified) {
          const apiResponse = {
            userProfile: result?.data?.Result?.Table1[0],
            token: result?.data?.Description,
            we3_key: result?.data?.Key,
          };
          setShowModal(true);
          dispatch(setLoginAttempt(apiResponse));
        } else {
          const apiResponse = {
            userProfile: result?.data?.Result?.Table1[0],
            token: result?.data?.Description,
            we3_key: result?.data?.Key,
          };
          dispatch(setProfile(apiResponse));
          setShowLoginForm(false);
          // window.location.reload();
        }

        return result;
      }
    } catch (err) {
      console.log(err);
      toast.error("Internal Server Error");
    }
  };

  useEffect(() => {
    if (user) {
      fetch(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
        {
          headers: {
            Authorization: `Bearer ${user.access_token}`,
            Accept: "application/json",
          },
        }
      )
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          const jsonData = res.json();
          return jsonData;
        })
        .then((data) => {
          console.log(data); // Log the parsed JSON data
          handleGoogleLogin(data);
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  return (
    <>
      {showModal && (
        <OtpCustomModal
          otpOwner={otpOwner}
          showModal={showModal}
          setShowModal={setShowModal}
          showOtpInput={showOtpInput}
          setShowLoginForm={setShowLoginForm}
          handleSendOtp={handleSendOtp}
          handleVerifyOtp={handleVerifyOtp}
          handleResendOTP={handleResendOTP}
        />
      )}

      <div className="d-flex flex-column gap-20">
        <div className="px-80 py-50 sm:px-20 sm:py-20 bg-white border-light rounded-16 relative">
          {showOtpInput && (
            <div
              className="fas fa-arrow-left border-primary text-12 text-primary fw-600 rounded-full px-10 py-10 text-center cursor-pointer h-30 w-30 button otp-back-btn"
              onClick={() => {
                setShowOtpInput(false);
              }}
            ></div>
          )}
          <div className="row y-gap-20">
            {!showOtpInput ? (
              <>
                <Formik
                  initialValues={{ phone: otpOwner ? otpOwner : "" }}
                  validationSchema={validationSchema}
                  onSubmit={(values) => {
                    console.log("Form values:", values);

                    handleSendOtp(values.phone);
                  }}
                >
                  {(formik) => (
                    <form onSubmit={formik.handleSubmit}>
                      <div className="col-12 mt-20 y-gap-10">
                        <div className="col-12 mt-20">
                          <div className="single-field y-gap-20">
                            <label className="text-13 fw-500">
                              Phone Number
                            </label>
                            <div className="form-control">
                              <PhoneInput
                                disableDialCodePrefill
                                disableDialCodeAndPrefix
                                showDisabledDialCodeAndPrefix
                                placeholder="00000-00000"
                                defaultCountry="in"
                                value={formik.values.phone}
                                onChange={(phone, e) => {
                                  // formik.setFieldValue("phone", phone);
                                  handlePhoneChange(phone, formik);
                                }}
                                inputStyle={{
                                  borderLeft: "0px",
                                }}
                                countrySelectorStyleProps={{
                                  paddingRight: "8px",
                                  paddingLeft: "8px",
                                }}
                              />
                            </div>
                            {formik.touched.phone && formik.errors.phone ? (
                              <div className="text-red-1 text-13">
                                {formik.errors.phone}
                              </div>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-12 mt-20 relative">
                          <button
                            disabled={verifyingMobile}
                            type="submit"
                            className="button w-full h-50 px-20 -grey-1 bg-grey text-white rounded-100 load-button"
                          >
                            {!verifyingMobile && "Send OTP"}
                            {verifyingMobile && (
                              <span class="btn-spinner"></span>
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              </>
            ) : (
              <OtpInput
                verifyingDevice={verifyingMobile}
                verifyingOtp={verifyingOtp}
                otpSentMessage={`Verification Code sent on +91 ${otpOwner}`}
                onOtpSubmit={handleVerifyOtp}
                resendOtp={handleResendOTP}
                detail={otpOwner}
              />
            )}
          </div>
          {/* {!showOtpInput && (
            <div className="row y-gap-20 pt-10">
              <div className="col-12">
                <div className="divider">
                  <div className="divider-content text-13">OR sign in with</div>
                </div>
                <div className="d-flex items-center justify-center">
                  <button
                    onClick={glogin}
                    className="button text-left col-12 -outline-dark-1 text-dark-1 py-15 px-30 rounded-100 mt-20 text-14 justify-center"
                    style={{ gap: "20px" }}
                  >
                    <img src={GoogleIcon} alt="google-icon" />
                    Continue with Google
                  </button>
                </div>
              </div>
              <div className="col-12">
                <div className="text-center text-10 lh-12 fw-500">
                  By creating an account you agree with our{" "}
                  <a href="#" className="text-primary underline">
                    {" "}
                    Terms & Conditions
                  </a>{" "}
                  and{" "}
                  <a href="#" className="text-primary underline">
                    {" "}
                    Privacy Policy.
                  </a>
                </div>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </>
  );
}

export default LoginForm;
